import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionMethodologyProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionMethodology({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionMethodologyProps) {
  const { t } = useTranslation();
  const methodology = article.methodology;

  if (!methodology) return null;

  return (
    <section data-gtm-section="methodology" data-gtm-order="4">
      <SectionTitle title={t("Methodology")} className="mb-4" />
      <ExpandableText isExpanded={isExpanded} setExpand={setExpand} lines={10}>
        <ScientificText>{methodology}</ScientificText>
      </ExpandableText>
    </section>
  );
}
